import { BaseProjectComponent } from '@layouts/default/layouts/logged/pages/project/components/base-project.component';
import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Error } from '@shared/interfaces/error.interface';
import { CartService } from '@layouts/default/layouts/logged/pages/cart/cart.service';
import { AppInjector } from '@shared/services/app-injector.service';

@Component({
  selector: 'app-child-info',
  templateUrl: './child-info.component.html',
  styleUrls: ['./child-info.component.scss'],
})
export class ChildInfoComponent extends BaseProjectComponent {
  cartService: CartService;
  @Input() correctForm: UntypedFormGroup = new UntypedFormGroup({});
  @Output() childSuccess: EventEmitter<any> = new EventEmitter();
  @Output() childClose: EventEmitter<any> = new EventEmitter();
  displayChildInfoModal: boolean = false;
  currentValueSetChildren: UntypedFormControl = null;
  disabled: boolean = false;
  appendChildren: boolean = false;
  isAdult = false;
  allowPolicy = false;
  allowRODO = false;
  safeByMe = false;
  childrenNumber = 0;
  key = 'child_counter';
  @HostListener('window:beforeunload', ['$event'])
  public checkData() {
    if (this.displayChildInfoModal) {
      return false;
    }
  }

  constructor() {
    super();
    const injector = AppInjector.getInjector();
  }

  get socialUserInfo() {
    return this.storage.user && (this.storage.user.facebook_id || this.storage.user.googleplus_id);
  }

  onChildrenAddError(error: Error) {
    this.loading = false;
    this.disabled = false;
    this.toast.error(
      this.translate.instant('EVENT.child_modal.error'),
      this.translate.instant('EVENT.child_modal.error_description')
    );
  }

  joinWithChildren() {
    if (this.correctForm.invalid && this.appendChildren) {
      this.correctForm.markAllAsTouched();
      return;
    }
    this.childrenNumber = this.appendChildren ? this.correctForm.get(this.key).value : 0;
    this.displayChildInfoModal = false;
    this.childSuccess.emit(this.childrenNumber);
  }

  closeModal() {
    this.displayChildInfoModal = false;
    this.childClose.emit();
  }

  isActive() {
    return this.isAdult && this.allowPolicy && this.allowRODO && this.safeByMe;
  }

  toogleAdult() {
    this.isAdult = !this.isAdult;
    console.log(this.isAdult);
  }

  toogleAllowPolicy() {
    this.allowPolicy = !this.allowPolicy;
  }

  toogleUnderageCounter() {
    this.appendChildren = !this.appendChildren;
  }

  toogleAllowRODO() {
    this.allowRODO = !this.allowRODO;
  }

  toogleSafeByMe() {
    this.safeByMe = !this.safeByMe;
  }

  saveSetValue(event: UntypedFormControl) {
    const minimum = 1;

    if (event.value.indexOf(',') > 0 || event.value.indexOf('.') > 0 || +event.value < 0) {
      return;
    } else {
      this.currentValueSetChildren = event;
      this.changeChildInput(event);
    }
  }

  changeChildInput(event) {
    if (this.loading) {
      return;
    }
    if (
      +event.value === 0 ||
      event.value.search(',') > 0 ||
      event.value.search('.') > 0 ||
      event.value > 9
    ) {
      this.toast.error(
        this.translate.instant('EVENT.child_modal.error_input_part1'),
        this.translate.instant('EVENT.child_modal.child_error')
      );
      return;
    }
    console.log('ok', event.value);
    this.childrenNumber = event.value;
  }
}
